var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"courses-dashboard_head-rating"},[_c('div',{staticClass:"dashboard-stars"},[_c('star-rating',{attrs:{"max-rating":5,"increment":0.1,"rating":_vm.item.userCourse.data.rating.data.value,"star-points":[
                23,
                1,
                15,
                17,
                0,
                18,
                12,
                30,
                5,
                47,
                23,
                38,
                40,
                47,
                34,
                30,
                47,
                18,
                30,
                17,
            ],"inactive-color":_vm.item.header.data.colorRatingInactive,"active-color":_vm.item.header.data.colorRatingActive,"read-only":true,"show-rating":false}}),_c('span',[_vm._v("\n            "+_vm._s(_vm.item.userCourse.data.rating.data.value)+"\n        ")]),_c('span',[_vm._v(" ("+_vm._s(_vm.item.userCourse.data.rating.data.count)+") ")])],1),_c('div',{staticClass:"dashboard-time"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.item.materialsCount)+" "+_vm._s(_vm.declensionWord(_vm.item.materialsCount))+"\n        ")]),_vm._v("\n        ·\n        "),_c('span',[_vm._v("\n            "+_vm._s(_vm.totalTimeModule)+"\n        ")])]),_c('div',{staticClass:"dashboard-bookmark"},[_c('button',{style:({ color: _vm.item.header.data.colorDescription }),on:{"click":function($event){$event.preventDefault();return _vm.onClickFavorite(_vm.item)}}},[_c('span',[_c('svg',{attrs:{"width":"13","height":"16","viewBox":"0 0 13 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.92774 11.376L6.51172 11.0986L6.09569 11.376L1.26172 14.5986V0.75H11.7617V14.5986L6.92774 11.376Z","stroke":!_vm.item.userCourse.data.pin
                                ? _vm.item.header.data.colorDescription
                                : _vm.item.header.data.colorRatingActive,"fill":!_vm.item.userCourse.data.pin
                                ? ''
                                : _vm.item.header.data.colorRatingActive,"stroke-width":"1.5"}})])]),_c('span',[_vm._v(_vm._s(_vm.$t("addToBookmark")))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }